import React, { useEffect, useState, useRef, useCallback } from "react";
import { Modal, Descriptions, Image, Card, Button, Table, Space, Form, Select, Input, Spin, } from "antd";
import { getEvent, getKyus, updateCustomer, getBelts, getClasses, getStudent, } from "../../constants/API/API";
import useApi from "../../hooks/useApi";
import moment from "moment";
import { useNavigate, useParams } from "react-router";
import { BackwardOutlined, DeleteOutlined, EditOutlined, LeftOutlined, } from "@ant-design/icons";
import CustomTable from "../../components/CustomTable";
import DeleteModal from "../../components/DeleteModal";
import callApi from "../../constants/API/CallApi";
import useRequest from "../../hooks/useRequest";
import { Severty, ShowToast } from "../../helper/toast";

const PAGE_SIZE = 10;
const { Option } = Select;
const EventView = () => {
  const [event, setEmployee] = useState(null);
  const [isAdd, setIsAdd] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [selected, setSelected] = useState();
  const [refresh, setRefresh] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [editBeltModal, setEditBeltModal] = useState(false);
  const [selectedStudentForBelt, setSelectedStudentForBelt] = useState(null);
  const [updateBeltLoading, setUpdateBeltLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [kyuOptions, setKyuOptions] = useState([]);
  const [belts, setBelts] = useState([]);
  const [classList, setClassList] = useState([]);
  const [parents, setParents] = useState([]);
  const [selectedParticipantId, setSelectedParticipantId] = useState(null);

  const [studentSearch, setStudentSearch] = useState("");
  const [studentPage, setStudentPage] = useState(1);
  const [studentTotal, setStudentTotal] = useState(0);
  const [studentLoading, setStudentLoading] = useState(false);
  const searchTimerRef = useRef(null);

  const fetchStudents = useCallback(async ({ page = 1, search = "", append = false } = {}) => {
    setStudentLoading(true);
    try {
      const res = await getStudent({ roleType: "student", page, limit: PAGE_SIZE, search });
      const { data: list = [], total = 0 } = res?.data || {};
      setStudentTotal(total);
      setParents((prev) => append ? [...prev, ...list] : list);
      setStudentPage(page);
    } catch (err) {
      console.error("Failed to fetch students", err);
    } finally {
      setStudentLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStudents({ page: 1, search: "", append: false });
  }, [refresh]);

  const handleStudentSearch = (value) => {
    setStudentSearch(value);
    if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
    searchTimerRef.current = setTimeout(() => {
      fetchStudents({ page: 1, search: value, append: false });
    }, 400);
  };

  const handleStudentPopupScroll = (e) => {
    const { target } = e;
    const isNearBottom = target.scrollTop + target.offsetHeight >= target.scrollHeight - 20;
    const hasMore = parents.length < studentTotal;
    if (isNearBottom && hasMore && !studentLoading) {
      fetchStudents({ page: studentPage + 1, search: studentSearch, append: true });
    }
  };

  const handleCancel = () => {
    setIsAdd(false);
    form.resetFields();
  };

  useApi({
    callback: getEvent,
    payload: id,
    dependencies: [id, refresh],
    shouldCallApi: Boolean(id),
    onSuccess: (data) => {
      setEmployee(data);
    },
  });

  useApi({
    callback: getKyus,
    payload: {
      value: selected?.kyu?.requiredClasses,
      beltId: selected?.beltId,
      userId: selected?.user?._id,
    },
    dependencies: [selected, refresh],
    shouldCallApi: true,
    onSuccess: (data) => {
      console.log(data);
      setLoading(false);
      setKyuOptions(data?.data || []);
    },
    onError: (err) => {
      console.log(err);
      setLoading(false);
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [classRes, belts] = await Promise.all([getClasses(), getBelts()]);
        setBelts(belts?.data?.data || []);
        setClassList(classRes?.data?.data || []);
      } catch (error) {
        setBelts([]);
        setClassList([]);
      }
    };
    fetchData();
  }, []);


  const handleEditBelt = (user) => {
    console.log("user>>>>>>>", user);
    setSelectedStudentForBelt(user);
    setEditBeltModal(true);
  };


  const handleUpdateBelt = () => {
    if (!selectedStudentForBelt?.newBelt) {
      return ShowToast("Please select a belt!", "error");
    }

    setUpdateBeltLoading(true);

    callApi({
      callback: updateCustomer,
      payload: [
        { beltId: selectedStudentForBelt.newBelt },
        selectedStudentForBelt?._id,

      ],
      onSuccess: ({ message }) => {
        ShowToast(message, Severty.SUCCESS);
        setRefresh((x) => !x);
        setEditBeltModal(false);
        setSelectedStudentForBelt(null);
        setUpdateBeltLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setUpdateBeltLoading(false);
      },
    });
  };

  const columns = [
    {
      title: "Student Name",
      dataIndex: "userId",
      key: "studentName",
      render: (_, record) => <p>{record?.userId?.name || "-"}</p>,
    },
    {
      title: "Parent Name",
      key: "parentName",
      render: (_, record) => (
        <p>{record?.userId?.parentId?.name || "-"}</p>
      ),
    },
    {
      title: "Email",
      key: "parentEmail",
      render: (_, record) => (
        <p>{record?.userId?.parentId?.email || "-"}</p>
      ),
    },

    {
      title: "Belt",
      dataIndex: ["belt", "name"],
      render: (_, record) => (
        <Button type="link" onClick={() => handleEditBelt(record?.userId)}>
          {record?.userId?.beltId?.name || "-"}
        </Button>
      ),
    },

    // {
    //   title: "Kyu",
    //   key: "kyu",
    //   render: (_, record) => (
    //     <p>{record?.userId?.kyuId?.name || "-"}</p>
    //   ),
    // },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => {
              setIsDelete(true);
              setSelected(record?._id);
            }}
            icon={<DeleteOutlined />}
            title="Remove"
          />
        </Space>
      ),
    },
  ];

  const handleAdd = (values) => {
    request({
      url: "admin/event/add-member",
      method: "POST",
      data: {
        eventId: id,
        userId: values.parentId,
      },
      onSuccess: (data) => {
        setRefresh((x) => !x);
        ShowToast(data?.message, Severty.SUCCESS);
        handleCancel();
      },
      onError: (err) => {
        ShowToast(err?.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const handleDelete = () => {
    request({
      url: `admin/event/delete-member/${id}`,
      method: "DELETE",
      data: { participantId: selected },
      onSuccess: (data) => {
        setRefresh((x) => !x);
        setIsDelete(false);
        ShowToast(data?.message, Severty.SUCCESS);
      },
      onError: (err) => {
        ShowToast(err?.response?.data?.message, Severty.ERROR);
      },
    });
  };

  return (
    <div>
      <Button
        type="default"
        className="mb-2"
        style={{ color: "black" }}
        onClick={() => navigate(-1)}
      >
        <LeftOutlined />
      </Button>
      <Card>
        <div>
          <div className="text-center mb-4">
            {event?.profilePic && (
              <Image
                src={event?.profilePic}
                alt="Profile"
                style={{ width: 150, height: 150, borderRadius: "50%" }}
              />
            )}
          </div>
          <Descriptions bordered column={1} className="new-icon-page">
            <Descriptions.Item label="Title">{event?.title}</Descriptions.Item>
            <Descriptions.Item label="Address">
              {event?.address}
            </Descriptions.Item>
            <Descriptions.Item label="Capacity">
              {event?.capacity || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Description">
              <div
                className="event-detail-detail"
                dangerouslySetInnerHTML={{ __html: event?.description }}
              />
            </Descriptions.Item>
            <Descriptions.Item label="Date & Time">
              {moment(event?.dateTime).format("lll")}
            </Descriptions.Item>
            <Descriptions.Item label="Eligibility Criteria">
              <div>
                <p>
                  Class -{" "}
                  {event?.eligibility?.class
                    ?.map((item) => item?.name)
                    ?.join(", ")}
                </p>
                <p>
                  Belt -{" "}
                  {event?.eligibility?.belt
                    ?.map((item) => item?.name)
                    ?.join(", ")}
                </p>
              </div>
            </Descriptions.Item>
            <Descriptions.Item label="Created At">
              {moment(event?.createdAt).format("ll")}
            </Descriptions.Item>
            <Descriptions.Item label="Event Banner">
              <Image src={event?.media} />
            </Descriptions.Item>
            <Descriptions.Item label="Event Gallery">
              {event?.gallery?.map((src) => {
                return <Image src={src} />;
              })}
            </Descriptions.Item>
          </Descriptions>
        </div>

        <div>
          <div className="add-buttondiv">
            <Button
              onClick={() => setIsAdd(true)}
              className="mb-3 mt-3"
              type="primary"
            >
              Add Member
            </Button>
          </div>

          <Table
            columns={columns}
            dataSource={event?.participants || []}
          // title={"Participants"}
          />
        </div>
      </Card>

      {isDelete && (
        <DeleteModal
          hide={() => setIsDelete(false)}
          onOk={() => handleDelete()}
          show={isDelete}
          title={"Remove Participants!"}
          subtitle={
            "Are you sure you want to remove the participant from the event ?"
          }
        />
      )}

      {isAdd && (
        <Modal
          title="Add Member"
          open={isAdd}
          onCancel={handleCancel}
          className="tab_modal"
          okText="Add"
          cancelText="Cancel"
          okButtonProps={{
            form: "member-form",
            htmlType: "submit",
          }}
        >
          <Form
            form={form}
            onFinish={handleAdd}
            id="member-form"
            layout="vertical"
            name="add_member_form"
          >
            <Form.Item
              name="parentId"
              label="Select Student"
              rules={[{ required: true, message: "Please student parent" }]}
            >
              <Select
                showSearch
                filterOption={false}
                placeholder="Search & select student"
                onSearch={handleStudentSearch}
                onPopupScroll={handleStudentPopupScroll}
                notFoundContent={studentLoading ? <Spin size="small" /> : "No students found"}
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    {studentLoading && parents.length > 0 && (
                      <div style={{ textAlign: "center", padding: "8px 0" }}>
                        <Spin size="small" />
                      </div>
                    )}
                    {!studentLoading && parents.length > 0 && (
                      <div style={{ textAlign: "center", padding: "4px 0", color: "#999", fontSize: 12 }}>
                        {parents.length} / {studentTotal} loaded
                      </div>
                    )}
                  </>
                )}
              >
                {parents?.map((parent) => (
                  <Option key={parent._id} value={parent._id}>
                    {parent.name} {parent.parentId?.email ? `(${parent.parentId.email})` : ""}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
        </Modal>
      )}



      <Modal
        open={editBeltModal}
        title="Update Student Belt"
        onOk={handleUpdateBelt}
        okText="Update"
        confirmLoading={updateBeltLoading}
        onCancel={() => {
          setEditBeltModal(false);
          setSelectedStudentForBelt(null);
        }}
      >
        <p>Select Belt</p>
        <Select
          placeholder="Select Belt"
          style={{ width: "100%" }}
          value={selectedStudentForBelt?.newBelt}
          onChange={(value) =>
            setSelectedStudentForBelt((prev) => ({ ...prev, newBelt: value }))
          }
        >
          {belts?.map((belt) => (
            <Option key={belt._id} value={belt._id}>
              {belt.name}
            </Option>
          ))}
        </Select>
      </Modal>


    </div>
  );
};

export default EventView;
